/* eslint-disable no-undef, react/prop-types */
import React from 'react';
import Link from 'gatsby-link';
import { css } from 'react-emotion';
import { Content, Columns, Section, Container, Tile, Box, Table } from 'react-bulma-components';


let product = (name, url, backgroundUrl) => {
	if (!url) {
		url = 'https://google.com'
	}
	if (!backgroundUrl) {
		backgroundUrl = '/robloach.png'
	}
	let linkClassNames = [
		'tile',
		'is-child',
		'notification'
	].join(' ')

	let bgImage = [
		'bg',
		css`background-image: url(${backgroundUrl});`
	].join(' ')
	if (url) {
		if (url.startsWith("http")) {
			return (
				<Tile className="is-parent">
					<a href={url} className={linkClassNames}>
						<div className={bgImage} />
						<p class="title is-3">{name}</p>
					</a>
				</Tile>
			)
		}
		else {
			return (
				<Tile className="is-parent">
					<Link to={url} className={linkClassNames}>
						<div className={bgImage} />
						<p class="title is-3">{name}</p>
					</Link>
				</Tile>
			)
		}
	}
}

export default () => {
	return (
		<Section className="main">
			<Content className="portfolio">
				<h1>Portfolio</h1>
				<Tile className="is-ancestor">
					{product('GreenBiz')}
					{product('Fast Company', '/drupal')}
				</Tile>
				<Tile className="is-ancestor">
					{product('Drupal', '/drupal', '/drupal.jpg')}
					{product('JavaScript', 'http://jquery.com', '/javascript.png')}
				</Tile>

				<h1>Friends</h1>

				<Tile className="is-ancestor">
					{product('Kalamuna', 'https://kalamuna.com', '/kalamuna.png')}
				</Tile>
				<Tile className="is-ancestor">
					{product('Myplanet')}
					{product('Acquia')}
					{product('Mansueto')}
				</Tile>

				<h1>Musings</h1>

				<Table className="is-fullwidth is-striped">
					<tbody>
						<tr>
							<td><a href="https://www.libretro.com/index.php/chailove/">ChaiLove - 2D Game Development</a></td>
							<td>December 26, 2017</td>
						</tr>
						<tr>
							<td><a href="https://www.libretro.com/index.php/retroarch-with-flatpak">RetroArch with Flatpak</a></td>
							<td>July 26, 2017</td>
						</tr>
						<tr>
							<td><a href="https://blog.kalamuna.com/news/why-we-put-mother-jones-mag-facebook-instant-articles">Mother Jones Magazine on Facebook Instant Articles</a></td>
							<td>November 17, 2016</td>
						</tr>
					</tbody>
				</Table>

			</Content>
		</Section>



	)
}

/*
			<Box bg={colors.primary}>
				<Box
					width={[1, 1, 1 / 2]}
					m={['3.5rem 0 0 0', '3.5rem 0 0 0', '3.5rem auto 0 auto']}
					px={[3, 3, 0]}
					color={colors.secondary}
					align="center"
				>
					<h1>{myData.title}</h1>
					<h3>{myData.subtitle}</h3>
					<Flex justify="center" wrap={['wrap', 'wrap', 'nowrap']}>
						<Box m={[1]} width={[1, 1 / 2, 1 / 4]}>
							<Link to="/about">
								<ButtonPrimary>About</ButtonPrimary>
							</Link>
						</Box>
						<Box m={[1]} width={[1, 1 / 2, 1 / 4]}>
							<Link to="/about">
								<ButtonSecondary>About</ButtonSecondary>
							</Link>
						</Box>
					</Flex>
				</Box>
			</Box>
			<Box bg={colors.primary} py={[3, 3, 4]}>
				<Box
					width={[1, 1, 1 / 2]}
					m="0 auto"
					px={[3, 3, 0]}
					color={colors.secondary}
				>
					<h1>This could be another section</h1>
					<p>With another text object</p>
				</Box>
			</Box>
		</div>
	);
};
*/


// WEBPACK FOOTER //
// ./src/pages/index.js